import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_ctx.props.radioButton)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_a_radio_group, {
          value: _ctx.computedValor,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedValor) = $event)),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.defineValorMarcado($event))),
          "button-style": "solid",
          onBlur: _ctx.blur,
          disabled: _ctx.props.disabled
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio_button, { value: 1 }, {
              default: _withCtx(() => [
                _createTextVNode("Nota Fiscal Eletrônica(NFe)")
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: 2 }, {
              default: _withCtx(() => [
                _createTextVNode("Cupom Eletrônico(NFCe)")
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: 3 }, {
              default: _withCtx(() => [
                _createTextVNode("Nota Fiscal de Serviço(NFSe)")
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: 4 }, {
              default: _withCtx(() => [
                _createTextVNode("Carta de Correção(CCe)")
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: 5 }, {
              default: _withCtx(() => [
                _createTextVNode("Manifesto de Documentos Fiscais(MDFe)")
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: 6 }, {
              default: _withCtx(() => [
                _createTextVNode("Conhecimento de Transporte(CTe)")
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: 7 }, {
              default: _withCtx(() => [
                _createTextVNode("Recibo")
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: 8 }, {
              default: _withCtx(() => [
                _createTextVNode("Fatura")
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: 9 }, {
              default: _withCtx(() => [
                _createTextVNode("Adiantamento")
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: 10 }, {
              default: _withCtx(() => [
                _createTextVNode("Contrato")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "onBlur", "disabled"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_a_select, {
          value: _ctx.computedValor,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedValor) = $event)),
          onChange: _ctx.defineValorSelecionado,
          class: "ss-tamanho-completo",
          onBlur: _ctx.blur,
          allowClear: _ctx.props.limparSelecao,
          disabled: _ctx.props.disabled,
          placeholder: _ctx.props.placeholder
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select_option, { value: 1 }, {
              default: _withCtx(() => [
                _createTextVNode("Nota Fiscal Eletrônica(NFe)")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: 2 }, {
              default: _withCtx(() => [
                _createTextVNode("Cupom Eletrônico(NFCe)")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: 3 }, {
              default: _withCtx(() => [
                _createTextVNode("Nota Fiscal de Serviço(NFSe)")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: 4 }, {
              default: _withCtx(() => [
                _createTextVNode("Carta de Correção(CCe)")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: 5 }, {
              default: _withCtx(() => [
                _createTextVNode("Manifesto de Documentos Fiscais(MDFe)")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: 6 }, {
              default: _withCtx(() => [
                _createTextVNode("Conhecimento de Transporte(CTe)")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: 7 }, {
              default: _withCtx(() => [
                _createTextVNode("Recibo")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: 8 }, {
              default: _withCtx(() => [
                _createTextVNode("Fatura")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: 9 }, {
              default: _withCtx(() => [
                _createTextVNode("Adiantamento")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: 10 }, {
              default: _withCtx(() => [
                _createTextVNode("Contrato")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "onChange", "onBlur", "allowClear", "disabled", "placeholder"])
      ]))
}